<template>
  <div>
   
    <vs-button
      color="Danger"
      type="border"
      icon-pack="feather"
      icon="icon-trash"
      class="mr-2"
    ></vs-button>
  
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { deleteClient } from '@/api/admission.js'
export default {
  name: 'CellRendererActions',
  mounted () {
    console.log(this.params.data.basic_details.client_users_id)
  },
  data () {
    return {
      action: {},
      toggle: null
    }
  },
  methods: {
    ...mapActions(['SET_CLIENT_DELETE_ID']),
    async haldleDelete () {
      const deleting_id = this.params.data.basic_details.client_users_id
      const payload = {
        client_user_id: [deleting_id]
      }
      
      if (!this.params.data.actionData.toggle) {
        if (this.params.data.basic_details.user_type === 'Parent' && this.params.data.children.length > 0) {
          const initial = this.params.data.children[0].child.active_user === '1'
          const ischildDeactive = this.checkAllChildDeactive(this.params.data.children, initial)
          if (!ischildDeactive) {
            try {
              const data = await deleteClient(payload)
              this.SET_CLIENT_DELETE_ID(deleting_id)
              
              this.$vs.notify({
                title: 'Client Deteled',
                text: 'Client Deteled Successfull',
                ...this.successProp()
              })
            } catch (error) {
              
            }
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'Deactive all minor first',
              ...this.warnProp()
            })
          }
        } else {
          try {
            const data = await deleteClient(payload)
            this.SET_CLIENT_DELETE_ID(deleting_id)
            this.$vs.notify({
              title: 'Client Deteled',
              text: 'Client Deteled Successfull',
              ...this.successProp()
            })
          } catch (error) {
            
          }
        }


      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Can’t remove an active student. Please deactivate the student first',
          ...this.warnProp()
        })
      }
      
    },
    
  }
}
</script>
